import { DatePipe } from '@angular/common';
import { VenueDetailsOffer } from './venue-details.model';

export function appendDateWithSuffix(offer: VenueDetailsOffer, date: Date): string {
    if (offer.perkLabel.endsWith('1') && !offer.perkLabel.endsWith(' 11')) offer.perkLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.perkLabel.endsWith('2') && !offer.perkLabel.endsWith(' 12')) offer.perkLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.perkLabel.endsWith('3') && !offer.perkLabel.endsWith(' 13')) offer.perkLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.perkLabel.endsWith('1') || offer.perkLabel.endsWith('2') || offer.perkLabel.endsWith('3') || offer.perkLabel.endsWith('4') || offer.perkLabel.endsWith('5') || offer.perkLabel.endsWith('6')
        || offer.perkLabel.endsWith('7') || offer.perkLabel.endsWith('8') || offer.perkLabel.endsWith('9')
        || offer.perkLabel.endsWith('0')) offer.perkLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');
    return offer.perkLabel
}


export function convertToUTCDate(pendingPerkTime) {
    const fullDate = new Date(pendingPerkTime);
    return new Date(
        fullDate.getUTCFullYear(),
        fullDate.getUTCMonth(),
        fullDate.getUTCDate(),
        fullDate.getUTCHours(),
        fullDate.getUTCMinutes(),
        fullDate.getUTCSeconds()
    );
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-details/date-helper-venue.ts